module.exports = __webpack_public_path__ + "static/media/donation.24fda433.svg";